module.exports = __webpack_public_path__ + "static/media/watch.84fa0115.png";